// Execute the script after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  
  const stickyHeader = document.getElementById("stickyHeader");
  if (!stickyHeader) return;
  
  let lastScrollY = window.scrollY;
  window.addEventListener("scroll", function () {
    if (window.scrollY <= 0) {
      stickyHeader.classList.add("show");
    } else if (window.scrollY > lastScrollY) {
      stickyHeader.classList.remove("show");
    } else {
      stickyHeader.classList.add("show");
    }
    lastScrollY = window.scrollY;
  });
  
  // Mejorado: Verifica si el enlace es un anchor link o una URL externa
  document.querySelectorAll('.scroll-link').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      // Si es un anchor link (comienza con #)
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          const offset = 150; // Offset en píxeles aumentado a 150px
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;
          setTimeout(() => { 
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth"
            });
          }, 10); // Pequeña espera para asegurar que se calcule bien el offset
        }
      }
      // Si es una URL externa, deja que el comportamiento predeterminado continúe
      // No hacemos nada aquí para permitir la navegación normal
    });
  });
  
});